import { createTheme, PaletteOptions } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// /* Color Theme Swatches in Hex */
// .La-Duchesse-1-hex { color: #9AD9D9; } light blue
// .La-Duchesse-2-hex { color: #358C84; } darker blue
// .La-Duchesse-3-hex { color: #0F2622; } dark green
// .La-Duchesse-4-hex { color: #588C60; } lighter green
// .La-Duchesse-5-hex { color: #A9D9B0; } mint green
const greenPalette: PaletteOptions = {
  primary: {
    main: "#588C60",
    light: "#A9D9B0",
    dark: "#0F2622",
    contrastText: "#9AD9D9",
  },
  secondary: {
    main: "#358C84",
    light: "#9AD9D9",
    dark: "#0F2622",
    contrastText: "#A9D9B0",
  },
  text: {
    primary: "#0F2622",
    secondary: "#A9D9B0",
  },
  error: {
    main: red.A400,
  },
  background: {
    default: "#FDFFFE", // Set your desired background color here
  },
};

// /* Color Theme Swatches in Hex */
// .Kitchen-Remodel-1-hex { color: #F5EDDC; }
// .Kitchen-Remodel-2-hex { color: #CCBD9C; }
// .Kitchen-Remodel-3-hex { color: #C39F6A; }
// .Kitchen-Remodel-4-hex { color: #4D2518; }
// .Kitchen-Remodel-5-hex { color: #FFF5F3; }
const neutralsPalette: PaletteOptions = {
  primary: {
    main: "#C39F6A",
    light: "#CCBD9C",
    dark: "#4D2518",
    contrastText: "#F5EDDC",
  },
  text: {
    primary: "#4D2518",
    secondary: "#F5EDDC",
  },
  error: {
    main: red.A400,
  },
  background: {
    default: "#FFF5F3", // Set your desired background color here
  },
};

const green1 = "#FDFFFE";
const green2 = "#89D5AF";
const green3 = "#51AA7E";
const green4 = "#288054";
const green5 = "#0C5531";
const green6 = "#00331A";

const greenMonochromePalette: PaletteOptions = {
  primary: {
    main: green3,
    light: green2,
    dark: green4,
    contrastText: green1,
  },
  text: {
    primary: green6,
    secondary: green5,
  },
  error: {
    main: red.A400,
  },
  background: {
    default: green1, // Set your desired background color here
  },
};

// A custom theme for this app
const theme = createTheme({
  cssVariables: true,
  typography: {
    fontFamily: "komet, Arial, sans-serif",
    h1: {
      fontFamily: "komet-sc, Arial, sans-serif",
    },
  },
  palette: greenPalette,
});

export default theme;
